<template>
    <div class="card-header">
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <div class="input-group">
                        <select v-model="field" class="form-control col-md-3">
                            <option v-for="typefield in typeFields" :key="typefield.value" :value="typefield.value">{{typefield.label}}</option>
                        </select>
                        <input type="text" class="form-control" v-model="search" @input="changeFilter">
                        <button class="btn btn-theme"><i class="icon-fa icon-fa-search" @click="changeFilter"></i> Buscar</button>
                    </div>    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3">
                <router-link 
                    class="btn btn-theme btn-block"
                    :to="url"
                    target= '_blank'
                    v-if="isButton===false"
                >{{textButton}}</router-link>
                <button
                    class="btn btn-theme btn-block"
                    v-else
                    disabled
                >
                {{textButton}}
                </button>
            </div>
            <div class="col-lg-3">
                <multi-select v-model="place" :options="places" label="name" :disabled="isReadOnly" @input="changeFilter"/>
            </div>
            <div class="col-lg-2" v-for="state in status" :key="state.value">
                <div class="form-group">
                    <label v-text="state.label"></label>
                    <input type="radio" :value="state.value" v-model="selectStatus" :loading="Loading" @change="changeFilter">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    export default {
        props: {
            isButton:{
                type: Boolean
            },
            textButton: {
                type: String,
                default: 'Nueva compra'
            },
            status:{
                type: Array
            },
            isReadOnly:{
                type: Boolean
            },
            typeFields:{
                type: Array
            },
            url:{
                type: String
            }
        },
        components: {
            'multi-select': Multiselect,
        },
        data() {
            return {
                places: [],
                place: '',
                selectStatus:this.status[0].value,
                user:{},
                Loading:false,
                field:this.typeFields[0].value,
                search:'',

            }
        },
        methods: {
            getPlaces(Place) {
                let vm = this;
                vm.Loading=true;
                axios.get('/api/admin/place/getSelect')
                .then(function (response) {
                    vm.places=response.data.place;
                    vm.place=Place;
                    vm.Loading=false;
                    vm.changeFilter();
                })
                .catch(function (error) {
                    console.log(error);
                    vm.Loading=false;
                });
            },
            getUser() {
                let me = this;
                axios.get('/api/sale/getUser')
                .then((response) => {
                    me.user = response.data;
                    var Place={
                        id:me.user.placeId,
                        name:me.user.namePlace
                    }
                    me.getPlaces(Place);
                    // console.log(me.user);
                }).catch((error) => {
                    console.log(error);
                })
            },
            changeFilter(){
                this.$emit('change-filter',this.search,this.field,this.selectStatus,this.place.id);
            }
        },
        mounted(){
            this.getUser();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/utils/GenericHeader.vue